import locales from '@/locales/index';

/**
 * 获取卡牌的路径
 */
export const getCardUrl = (num) => {
    let url;
    //获取花色
    let t = (num & 0xf0) >> 4; //Math.floor(num / 100);
    //获取牌值
    let n = num & 0x0f; //num % 100;
    n = n === 14 ? 1 : n;
    // cz.log("=====> card 花色:" + t + " 牌值:" + n)
    if (num == 0) {
        //黑桃
        url = "/cards/back.png";
    } else if (t == 4) {
        //黑桃
        url = "/cards" + "/s_" + n + ".png";
    } else if (t == 3) {
        //红桃
        url = "/cards" + "/h_" + n + ".png";
    } else if (t == 2) {
        //梅花
        url = "/cards" + "/c_" + n + ".png";
    } else if (t == 1) {
        //方片
        url = "/cards" + "/d_" + n + ".png";
    }
    return process.env.REACT_APP_IMG_CDN + url;
};

/**
 * 表格汇总
 */
export const tableSummaries = (rawData, firstFiled, ...fileds) => {
    const exclueFileds = ['union_id', 'union_name', 'club_id', 'club_name', 'origin', 'desc', 'match_sum_detail', 'player_sum_detail', 'hands_sum_detail', 'profit_sum_detail', 'fee_sum_detail', 'ins_profit_sum_detail', 'ins_buy_sum_detail', 'desc', 'task_id', 'task_name', 'id', 'vendor_id', 'member_uid', 'kpoker_uid', 'name', 'recon_time', 'kind',]
    if (rawData.length === 0) return rawData;
    const columns = Object.keys(rawData[0]);
    if (fileds.length === 0) fileds = columns;
    const sums = {};
    columns.forEach((column, index) => {
        if (column === firstFiled) {
            sums[column] = getLanguage('summarize');
        } else {
            if (!exclueFileds.includes(column) && fileds.includes(column)) {
                const sum = rawData.reduce((sum, row) => {
                    const value = Number(row[column]);
                    return isNaN(value) ? sum : sum + value;
                }, 0);
                sums[column] = parseFloat(sum.toFixed(2));
            } else {
                sums[column] = "";
            }
        }
    });
    return [...rawData, sums];
};

/**
 * 根据key获取对应的语言内容
 */
export const getLanguage = (key, replace) => {
    const languageName = localStorage.getItem("languageName") || 'zh';
    if (locales[languageName] && locales[languageName][key]) {
        if (replace !== undefined) {
            return locales[languageName][key].replace('{}', replace);
        } else {
            return locales[languageName][key];
        }
    } else {
        return '';
    }
};

/**
 * 判断是否是手机端
 */
export const isMobileDevice = () => {
    return /Android|iPhone|iPod|iPad|Mobile/i.test(navigator.userAgent);
}
